/* Native details and Shopify forms work without JS, including editor re-renders. */
(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.tm-mobile-menu a');
    if (link) link.closest('details').open = false;
    document.querySelectorAll('.tm-dropdown[open], .tm-mobile-menu[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tm-dropdown[open], .tm-mobile-menu[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('.tm-faq details');
    if (details) details.open = true;
  });
})();
